export default [
  {
    chartId: '0e5696f5-df3d-4758-bb5d-390db2db6ca7',
    chartName: 'Structure Chart 1',
    chartFilter: [
      {
        name: 'BmGroup',
        text: 'vs US Univ',
        value: 'USUniv',
      },
    ],
    comments: [
      {
        id: '1',
        user: {
          id: '40',
          name: 'Peter K.',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'First comment',
        coords: {
          x: 200,
          y: 100,
        },
        replies: ['2', '3'],
      },
      {
        id: '2',
        user: {
          id: '41',
          name: 'Thomas R.',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '1',
      },
      {
        id: '3',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '1',
      },
      {
        id: '6',
        user: {
          id: '41',
          name: 'Thomas P.',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        coords: {
          x: 100,
          y: 100,
        },
        replies: ['4', '5', '9', '10'],
      },
      {
        id: '4',
        user: {
          id: '41',
          name: 'Thomas R.',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '6',
      },
      {
        id: '5',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '6',
      },
      {
        id: '9',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2022-01-01T00:23',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '6',
      },
      {
        id: '10',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2022-01-01T00:23',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '6',
      },
    ],
  },
  {
    chartName: 'Cost benchmark',
    chartId: 'aafcb4ff-a115-461d-a764-1f09e258c103',
    comments: [
      {
        id: '30',
        user: {
          id: '222',
          name: 'Renato Lovizotto',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'This is a test',
        coords: {
          x: 200,
          y: 100,
        },
        replies: ['5', '10'],
      },
      {
        id: '5',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '30',
      },
      {
        id: '10',
        user: {
          id: '222',
          name: 'Renato Lovizotto',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'This is a test',
        parentId: '30',
      },
      {
        id: '12',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        replies: ['15', '11', '13', '14'],
      },
      {
        id: '11',
        user: {
          id: '2',
          name: 'Renato Lovizotto',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'This is a test',
        coords: {
          x: 200,
          y: 100,
        },
        parentId: '12',
      },
      {
        id: '13',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '12',
      },
      {
        id: '14',
        user: {
          id: '2',
          name: 'Renato Lovizotto',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'This is a test',
        coords: {
          x: 200,
          y: 100,
        },
        parentId: '12',
      },
      {
        id: '15',
        user: {
          id: '42',
          name: 'J.J. Abrams',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'We have been participating since 1999 @ThomasR',
        parentId: '12',
      },
    ],
  },
  {
    chartName: 'Total plan performance Chart 1',
    chartId: 'e594652b-4fdb-4a34-a1c3-5b3057ae2664',
    comments: [],
    chartFilter: [
      {
        name: 'BmGroup',
        text: 'vs Global Univ',
        value: 'GBLUniv',
      },
      {
        name: 'MultiYear',
        text: '2 year period',
        value: '2',
      },
      {
        name: 'PerfFees',
        text: 'Include Performance Fees',
        value: 'InclPerf',
      },
    ],
  },
  {
    chartName: 'Reasons for differences Chart 3',
    chartId: '9e624cd5-c908-4cc4-9728-e40869b8b4ba',
    comments: [],
    chartFilter: [
      {
        name: 'BmGroup',
        text: 'vs US Univ',
        value: 'USUniv',
      },
      {
        name: 'MultiYear',
        text: '4 year period',
        value: '4',
      },
      {
        name: 'PerfFees',
        text: 'Exclude Performance Fees',
        value: 'ExclPerf',
      },
    ],
  },
  {
    chartName: 'Sales trend',
    chartId: 'b1c2d3e4-f5g6-h7i8-j9k0-l1m2n3o4p5q6r7',
    comments: [
      {
        id: '1',
        user: {
          id: '3',
          name: 'Jane Smith',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'I think the sales trend is going up',
        coords: {
          x: 400,
          y: 200,
        },
        replies: ['2'],
      },
      {
        id: '2',
        user: {
          id: '42',
          name: 'John Doe',
          avatar: '',
        },
        updated: '2023-01-03T11:00',
        text: 'I agree, the data supports that @JaneSmith',
        parentId: '1',
      },
    ],
  },
  {
    chartName: 'Revenue forecast',
    chartId: 'c1d2e3f4-g5h6-i7j8-k9l0-m1n2o3p4q5r6s7',
    comments: [
      {
        id: '3',
        user: {
          id: '4',
          name: 'Emily Johnson',
          avatar: '',
        },
        updated: '2023-01-03T10:50',
        text: 'I think the revenue forecast is too optimistic',
        coords: {
          x: 600,
          y: 300,
        },
        replies: ['4', '5'],
      },
      {
        id: '4',
        user: {
          id: '42',
          name: 'Mike Williams',
          avatar: '',
        },
        updated: '2023-01-03T11:00',
        text: 'I disagree, the market looks promising @EmilyJohnson',
        parentId: '3',
      },
      {
        id: '5',
        user: {
          id: '2',
          name: 'David Miller',
          avatar: '',
        },
        updated: '2023-01-03T11:05',
        text: 'I think we should be cautious but optimistic',
        parentId: '3',
      },
    ],
  },
]
